import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'fac_failing_comply_legal_req_working_hours_pertaining'

export const dataPointDefinition = {
  retracedId: 'fac_failing_comply_legal_req_working_hours_pertaining',
  name: 'Is the facility failing to comply with any legal requirements for Working Hours pertaining to non-production workers and',
  description:
    'Answer No if the facility is complying with all legal requirements on Working Hours pertaining to non-production workers and/or onsite sub-contracted workers. ',
  meta: {
    slcpMeta: {
      key: 'wh-wor-11',
      number: 'WH-WOR-28',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-11', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36480,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
